import { Stack, StackProps, styled } from '@mui/material';

export const TileImage = styled('img')(() => ({
  width: '100%',
  height: 240,
  objectFit: 'contain',
  borderRadius: 8,
}));

export const StudentRespondCell = styled((props: StackProps) => (
  <Stack direction="row" alignItems="center" gap={1} {...props} />
))(() => ({
  '& svg': {
    fontSize: '1.25rem',
  },
}));
